export default __webpack_public_path__ + "static/media/startup1.0b95af6d.gif";